import { render, staticRenderFns } from "./main_content.vue?vue&type=template&id=352eb7b7&scoped=true"
import script from "./main_content.vue?vue&type=script&lang=js"
export * from "./main_content.vue?vue&type=script&lang=js"
import style0 from "./main_content.vue?vue&type=style&index=0&id=352eb7b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352eb7b7",
  null
  
)

export default component.exports